import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { BoxMessage } from '../../models/boxmessage';

// import { environment } from './../../../environments/environment';
// environment.socketIO.timeout

@Component({
  selector: 'app-thanks-demo',
  templateUrl: './thanks-demo.component.html',
  styleUrls: ['./thanks-demo.component.scss']
})
export class ThanksDemoComponent extends BaseComponent implements OnInit {

  option:number = 0;
  poll:any;
  pollAnswer:any;
  timer:any;
  order:any = this.localSession.getOrder();
  subscription:any;

  ngOnInit(): void {
    this.poll = this.localSession.getPoll();

    this.subscription = this.boxService.getMessages()
        .subscribe((msg: BoxMessage) => { 

          if (msg.action == 'status' && msg.params == 'closed') {
            this.timer = setTimeout(() => {
              this.gotoIdle();
            }, 10 * 1000);
          }
    });
  }

  goto(val:number):void{
  	this.option = val;
  }

  answer(option:any){
    clearTimeout(this.timer);

    this.pollAnswer = option;

    this.boxService.answerPoll(this.order.hash_id, this.poll.name, this.pollAnswer.name);

    this.timer = setTimeout(() => {
      this.gotoIdle();
    }, 5 * 1000);
  }

  getAnswerTitle(){
    if (this.pollAnswer.response_title) {
      return this.pollAnswer.response_title;
    }

    return this.poll.default_response_title;
  }

  getAnswerDescription(){
    if (this.pollAnswer.response_text) {
      return this.pollAnswer.response_text;
    }

    return this.poll.default_response_text;
  }

  gotoIdle(){
    clearTimeout(this.timer);

    if (!this.pollAnswer) {
      this.boxService.answerPoll(this.order.hash_id, this.poll.name, '');
    }

    this.router.navigate(['/IdleStateComponent']);
  }

  ngOnDestroy(){
    clearTimeout(this.timer);
    this.subscription.unsubscribe();
  }

}
